import { useCallback } from 'react'
import { unauthedApi as api } from '~/src/api'
import { ApiLeadModel, LeadExperiment, LeadModel } from './types'

export function useCreateLeadModel(): (
  lead: Record<string, string | LeadExperiment[]>
) => Promise<ApiLeadModel> {
  return useCallback((lead: Record<string, string | LeadExperiment[]>): Promise<ApiLeadModel> => {
    return api.post('leads/async', { json: { ...lead, source_url: document.referrer } }).json()
  }, [])
}

export function useUpdateLeadModel(): (
  leadId: string | undefined,
  lead: Partial<LeadModel>
) => Promise<ApiLeadModel> {
  return useCallback(async (leadId, lead): Promise<ApiLeadModel> => {
    await api.patch(`leads/${leadId}`, { json: lead }).json()
    const leadResponse = await api.get(`leads/${leadId}`).json()
    return leadResponse as ApiLeadModel
  }, [])
}

export function useGetExistingLeadModel(): (email: string) => Promise<ApiLeadModel | null> {
  return useCallback(async (email: string) => {
    const response = await api.get('leads', { searchParams: { email } }).json<ApiLeadModel | null>()
    return response
  }, [])
}

export function useFetchLeadModel(): (leadId: string) => Promise<ApiLeadModel> {
  return useCallback(async (leadId: string) => {
    const response = await api.get(`leads/${leadId}`).json()
    return response as ApiLeadModel
  }, [])
}
